import React from 'react';
import { Card, CardContent, Avatar, Chip } from '@material-ui/core';
import PropTypes from 'prop-types';
import moment from 'moment';
import { makeStyles } from '@material-ui/core/styles';
import { getStatus } from '../../helpers/utils'; 
import ConfiLogo from "../../images/Confindustria_solo_logo.png";

const useStyles = makeStyles((theme) => ({
  chip: {
    borderRadius: '6px',
    backgroundColor: '#E2E2E2',
    marginRight: '10px',
    marginBottom: '4px',
    color: '#333',
    '& .MuiChip-label': {
      fontSize: '16px',
      fontFamily: "Raleway",
      fontWeight:"normal",
      color:'#14121F',
    },
  },
  cardContent: {
    fontFamily: 'Raleway',
    backgroundColor: '#f5f5f5',
    width:'100%',
  },
  nohighlightedChip: {
    backgroundColor: 'white', 
  },
  eventName: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontWeight: 'bold',
    fontSize: '23px',
    height: '27px',
    marginBottom: '10px',
    fontFamily:'Raleway',
  },
  timeChipContainer: {
    justifyContent: 'space-between',
    alignItems: 'center', 
    marginTop: '25px', 
    width:'100%', 
    minWidth:'100%',
  },
  chipContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'row',
    fontSize: '16px',
    backgroundColor: 'f5f5f5',
  },
}));


const CardEvent = ({ logoSrc, labels, status: propStatus, statusColor,className,nome_evento,data_inizio,data_fine,isHighlighted  }) => {
  const classes = useStyles();

  const { text: statusText = '', color: statusDotColor = '' } = getStatus(data_inizio,data_fine) || {};

  const formatTime = (date) => moment(date).format('HH:mm');

  return (
    <Card style={{width:'100%', borderRadius: '16px', position: 'relative',boxShadow: 'none',}}>
      <CardContent  className={classes.cardContent} style={{backgroundColor: isHighlighted ? '#093F75' : '#f5f5f5'}}>
          <div style={{display: 'flex', alignItems: 'flex-start', marginBottom: '16px', }}>
            {/*    <Avatar
                  variant="square" 
                  src={logoSrc ?? ConfiLogo} 
                  style={{ width: '58px', height: '58px', borderRadius: '10px', marginRight: '16px', backgroundColor: 'white', objectFit:'contain'}}
                />*/}
                <div style={{display:'flex', flexDirection:'column', width:'100%'}}>
                  <div className={classes.eventName} style={{color: isHighlighted ? 'white': 'inherit'}}>
                    {nome_evento}
                  </div>
                  <span style={{color: isHighlighted ? 'white': 'inherit'}}>
                    {formatTime(data_inizio)} - {formatTime(data_fine)}
                  </span> 
                </div>
          </div>
          <div> 
            <div className={classes.timeChipContainer}>
              <div className={classes.chipContainer}>
                  <div>
                    {labels.map((label, index) => (
                    <Chip key={index} label={label} 
                      className={`${classes.chip} ${isHighlighted ? classes.chip : classes.nohighlightedChip }`}
                    />
                    ))}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', marginRight:'30px' }}>
                    {/* //status */}
                    <span style={{ color: isHighlighted ? 'white' : '#14121F', fontWeight: 'bold',marginRight:'10px' }} >
                    {statusText} 
                    </span>
                    {/* // statuscolor */}
                    <span style={{width: '16px',height: '16px', borderRadius: '50%',backgroundColor: statusDotColor,marginLeft: '4px' }}/>
                  </div>
                </div>
            </div>
          </div>
      </CardContent>
    </Card>
  );
};

CardEvent.propTypes = {
  logoSrc: PropTypes.string.isRequired,
  labels: PropTypes.arrayOf(PropTypes.string).isRequired,
  className: PropTypes.string, // Aggiungi questa prop
  isHighlighted: PropTypes.bool, // Aggiungi questa prop
};

CardEvent.defaultProps = {
  className: '', // Valore di default per la prop className
  isHighlighted:false
};


export default CardEvent;
